<template>
  <div>
    <USkeleton class="h-12 col-span-4 md:col-span-6" />
    <USkeleton class="h-12 col-span-2 md:col-span-6" />
    <USkeleton class="h-12 col-span-1" />
    <USkeleton class="h-12 col-span-5" />
  </div>
</template>
